import { MaterialReactTable } from "material-react-table";
import React from "react";
import { Label } from "reactstrap";

const ViewOfferChildTableForTier = ({ row, columns, tableFor }) => {
  const data =
    tableFor === "tier"
      ? row?.pricingModelNew
      : tableFor === "condition"
      ? row?.conditions
      : [];
  if (!data || data.length === 0) return null;

  return (
    <div>
      <Label className="card-title mb-0">
        {tableFor === "condition" ? "Conditions" : "Tier Pricing"}
      </Label>

      <MaterialReactTable
        columns={columns || []}
        data={data}
        enableTopToolbar={false}
        enableBottomToolbar={false}
        enablePagination={false}
        enableColumnActions={true}
        enableSorting={false}
        enableColumnFilters={false}
        muiTableHeadCellProps={{
          sx: {
            paddingX: "0px",
          },
        }}
        muiTableBodyCellProps={{
          sx: {
            borderBottom: "none !important",
            fontSize: "14px",
            paddingY: "4px",
            paddingX: "0px",
          },
        }}
        muiTableBodyRowProps={{
          hover: false,
          sx: {
            borderBottom: "none",
          },
        }}
        muiTablePaperProps={{ elevation: 0 }}
      />
    </div>
  );
};

export default ViewOfferChildTableForTier;
